export enum AuthConstants {
  REGISTER_START = "REGISTER_START",
  REGISTER_SUCCESS = "REGISTER_SUCCESS",
  LOGIN_SUCCESS = "LOGIN_SUCCESS",
  LOGOUT = "LOGOUT",
  ERROR = "ERROR",
  SET_LANG = "SET_LANG",
};

